import React, { useState, useRef, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../Footer'
import { FormField } from '../../FormField'
import { getMobileFormattedDate, validateBirthDate, validateLength } from '../../DateInput'
import Keyboard from '../../Keyboard'
import {
  setUIForwardAction,
  setUIBackwardsAction,
  setDriverFirstNameAction,
  setDriverLastNameAction,
  setDriverCitizenshipCodeAction,
  setDriverBirthDateAction,
  setDriverGenderAction,
  setDriverIndexAction,
} from '../../../actions/'
import { AppState } from '../../../reducers'
import { UI } from '../../../constants/ui'
import './driversInformation.less'
import Gender from '../../Gender'
import { CustomCaretProps } from '../../CustomCaret'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'
import { FormFieldInput } from '../../FormFieldInput'
import { INPUT_TYPE } from '../../../constants/inputTypes'
import { FormFieldCountryInput } from '../../FormFieldCountryInput'

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setUIBackwards: setUIBackwardsAction,
  setDriverFirstName: setDriverFirstNameAction,
  setDriverLastName: setDriverLastNameAction,
  setDriverCitizenshipCode: setDriverCitizenshipCodeAction,
  setDriverBirthDate: setDriverBirthDateAction,
  setDriverGender: setDriverGenderAction,
  setDriverIndex: setDriverIndexAction,
}
type DispatchProps = typeof mapDispatchToProps

const mapStateToProps = (state: AppState) => ({
  driverFirstName: state.reservationChange.drivers[0].firstName,
  driverLastName: state.reservationChange.drivers[0].lastName,
  driverCitizenshipCode: state.reservationChange.drivers[0].citizenship,
  driverBirthDate: state.reservationChange.drivers[0].birthDate,
  driverGender: state.reservationChange.drivers[0].gender,
  isDocumentRequires: state.reservation.isDocumentRequires,
  reservation: state.reservation.reservation,
})

type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps
let citizenshipDriverInput: HTMLInputElement | null = null

const Component: React.FC<Props> = ({
  setUIForward,
  setUIBackwards,
  setDriverFirstName,
  driverFirstName,
  setDriverLastName,
  driverLastName,
  setDriverCitizenshipCode,
  driverCitizenshipCode,
  setDriverBirthDate,
  driverBirthDate,
  setDriverGender,
  driverGender,
  setDriverIndex,
  isDocumentRequires,
  reservation,
}: Props) => {
  const { t } = useTranslation()
  const [citizenshipDriver, setCitizenshipDriver] = useState('')
  const [dateOfBirthDriver, setDateOfBirthDriver] = useState<{ driverBirthDate: string; dateValidation: boolean; cursorPosition?: number }>({
    driverBirthDate: driverBirthDate,
    dateValidation: validateBirthDate(driverBirthDate),
  })
  const [formatInput, setFormatInput] = useState('')
  const [activeInput, setActiveInput] = useState<any>()
  const [isKeyboardShown, setShowKeyboard] = useState(true)
  const [isCountrySelect, setIsCountrySelect] = useState(false)
  const [isNoCountry, setIsNoCountry] = useState(false)
  const [isInputFieldsError, setInputFieldsError] = useState({
    isFirstNameError: false,
    isLastNameError: false,
    isBirthDateError: false,
    isCountryNameError: false,
    isGenderInputError: false,
  })

  const firstNameDriverInput = useRef<HTMLInputElement>(null)
  const lastNameDriverInput = useRef<HTMLInputElement>(null)
  const dateOfBirthDriverInput = useRef<HTMLInputElement>(null)

  const refFirstNameCaret = useRef<CustomCaretProps>(null)
  const refLastNameCaret = useRef<CustomCaretProps>(null)
  const refDateOfBirthCaret = useRef<CustomCaretProps>(null)
  const refCountryCaret = useRef<CustomCaretProps>(null)

  const [, updateState] = useState<any>()
  const forceUpdate = useCallback(() => updateState({}), [])

  const mode = getMode()
  const isKioskMode = mode === MODE.KIOSK

  const updateCaretPosition = () => {
    switch (activeInput) {
      case firstNameDriverInput.current:
        refFirstNameCaret.current && refFirstNameCaret.current.updateCaretPosition()
        break
      case lastNameDriverInput.current:
        refLastNameCaret.current && refLastNameCaret.current.updateCaretPosition()
        break
      case citizenshipDriverInput:
        refCountryCaret.current && refCountryCaret.current.updateCaretPosition()
        break
      case dateOfBirthDriverInput.current:
        refDateOfBirthCaret.current && refDateOfBirthCaret.current.updateCaretPosition()
    }
  }

  const onChangeDateOfBirthDesktop = (value: string) => {
    const dateMaxLength = 10
    if (value.length <= (dateMaxLength + 1) && !!dateOfBirthDriverInput && !!dateOfBirthDriverInput.current) {
      const data = getMobileFormattedDate(dateOfBirthDriverInput.current, value, dateMaxLength)
      if (!!data) {
        setDateOfBirthDriver({ driverBirthDate: data.value, dateValidation: validateBirthDate(data.value), cursorPosition: data.cursorPosition })
        validateBirthDate(data.value) && setDriverBirthDate(data.value)
        setInputFieldsError({
          ...isInputFieldsError,
          isBirthDateError: validateLength(data.value, dateMaxLength) && !validateBirthDate(data.value),
        })
      } else {
        forceUpdate()
      }

    } else {
      forceUpdate()
    }
  }

  const onChangeDateOfBirthKiosk = (value: string) => {
    if (value.length <= 10) {
      setDateOfBirthDriver({ driverBirthDate: value, dateValidation: validateBirthDate(value) })
      validateBirthDate(value) && setDriverBirthDate(value)
      setInputFieldsError({
        ...isInputFieldsError,
        isBirthDateError: validateLength(value, 10) && !validateBirthDate(value),
      })
    } else {
      forceUpdate()
    }
  }

  const onChange = (value: string) => {
    switch (activeInput) {
      case firstNameDriverInput.current:
        setInputFieldsError({ ...isInputFieldsError, isFirstNameError: false })
        setDriverFirstName(value)
        break
      case lastNameDriverInput.current:
        setInputFieldsError({ ...isInputFieldsError, isLastNameError: false })
        setDriverLastName(value)
        break
      case citizenshipDriverInput:
        setInputFieldsError({ ...isInputFieldsError, isCountryNameError: false })
        setCitizenshipDriver(value)
        setIsCountrySelect(false)
        break
      case dateOfBirthDriverInput.current:
        if (isKioskMode) {
          onChangeDateOfBirthKiosk(value)
        } else {
          onChangeDateOfBirthDesktop(value)
        }
        break
    }
    updateCaretPosition()
  }

  const onSelect = (option: string) => {
    setDriverCitizenshipCode(option)
    setIsCountrySelect(true)
  }

  const isAllDataValid = () => {
    return (
      dateOfBirthDriver.dateValidation &&
      driverFirstName &&
      driverFirstName.trim() &&
      driverLastName &&
      driverLastName.trim() &&
      isCountrySelect &&
      driverGender
    )
  }
  const onClick = () => {
    if (isAllDataValid()) {
      if (reservation && reservation.drivers[1]) {
        if (!isDocumentRequires) {
          setDriverIndex(1)
          setUIForward(UI.DRIVER2_INFORMATION)
        } else {
          setUIForward(UI.DOCUMENT_INFORMATION)
        }
      } else {
        if (!isDocumentRequires) {
          setUIForward(UI.SUMMARY)
        } else {
          setUIForward(UI.DOCUMENT_INFORMATION)
        }
      }
    } else {
      setInputFieldsError({
        isFirstNameError: !driverFirstName || !driverFirstName.trim(),
        isLastNameError: !driverLastName || !driverLastName.trim(),
        isBirthDateError:
          !validateBirthDate(dateOfBirthDriver.driverBirthDate) ||
          !validateLength(dateOfBirthDriver.driverBirthDate, 10),
        isCountryNameError: !isCountrySelect,
        isGenderInputError: !driverGender,
      })
    }
  }
  const clearInputField = (currentInput: any) => {
    setActiveInput(currentInput)
    setFormatInput('')
    switch (currentInput) {
      case firstNameDriverInput.current:
        setDriverFirstName('')
        break
      case lastNameDriverInput.current:
        setDriverLastName('')
        break
      case dateOfBirthDriverInput.current:
        setDateOfBirthDriver({ driverBirthDate: '', dateValidation: false })
        setInputFieldsError({ ...isInputFieldsError, isBirthDateError: false })
        setFormatInput('date')
        break
      case citizenshipDriverInput:
        setCitizenshipDriver('')
        setIsCountrySelect(false)
    }
  }

  const genderSelected = (value: string) => {
    setInputFieldsError({ ...isInputFieldsError, isGenderInputError: false })
    setDriverGender(value)
  }

  const onKeyboardDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode !== 13) {
      return
    }

    if (activeInput === firstNameDriverInput.current) {
      lastNameDriverInput.current && lastNameDriverInput.current.focus()
    } else if (activeInput === lastNameDriverInput.current) {
      citizenshipDriverInput && citizenshipDriverInput.focus()
    } else if (activeInput === citizenshipDriverInput) {
      dateOfBirthDriverInput.current && dateOfBirthDriverInput.current.focus()
    } else if (activeInput === dateOfBirthDriverInput.current) {
      onClick()
    }
  }

  useEffect(() => {
    setActiveInput(firstNameDriverInput.current)
  }, [])

  useEffect(() => {
    if (dateOfBirthDriverInput && dateOfBirthDriverInput.current && dateOfBirthDriver.cursorPosition !== undefined) {
      dateOfBirthDriverInput.current.selectionStart = dateOfBirthDriver.cursorPosition
      dateOfBirthDriverInput.current.selectionEnd = dateOfBirthDriver.cursorPosition
    }
  }, [dateOfBirthDriver])

  return (
    <React.Fragment>
      <Header showPageCount back={() => setUIBackwards(UI.FROM_TO)} />
      <div className="drivers-information">
        <div className="drivers-information-title" dangerouslySetInnerHTML={{ __html: t('driversInformationPassenger1Information') }}></div>
        <div className="drivers-information-content">
          <div className="drivers-information-row">
            <FormFieldInput
              id="first-name-driver"
              type={INPUT_TYPE.TEXT}
              classFormField={`drivers-form-field`}
              label={t('firstName')}
              isClearNeed={!!driverFirstName}
              clearInputField={clearInputField}
              errors={{ inputError: isInputFieldsError.isFirstNameError }}
              autoFocus
              inputRef={firstNameDriverInput}
              value={driverFirstName}
              onChange={onChange}
              onFocus={() => {
                setActiveInput(firstNameDriverInput.current)
                setFormatInput('')
              }}
              onClick={() => {
                setShowKeyboard(true)
                updateCaretPosition()
              }}
              onKeyDown={onKeyboardDown}
              caretRef={refFirstNameCaret}
              isActive={activeInput === firstNameDriverInput.current}
            />
            <FormFieldInput
              id="last-name-driver"
              type={INPUT_TYPE.TEXT}
              classFormField={`drivers-form-field`}
              label={t('lastName')}
              isClearNeed={!!driverLastName}
              clearInputField={clearInputField}
              errors={{ inputError: isInputFieldsError.isLastNameError }}
              inputRef={lastNameDriverInput}
              value={driverLastName}
              onChange={onChange}
              onFocus={() => {
                setActiveInput(lastNameDriverInput.current)
                setFormatInput('')
              }}
              onClick={() => {
                setShowKeyboard(true)
                updateCaretPosition()
              }}
              onKeyDown={onKeyboardDown}
              caretRef={refLastNameCaret}
              isActive={activeInput === lastNameDriverInput.current}
            />
            <FormFieldCountryInput
              id="citizenship-driver"
              classFormField="citizenship"
              label={t('citizenship')}
              sublabel={isNoCountry ? t('checkTheSpelling') : ''}
              onChange={onChange}
              onSelect={onSelect}
              setCountry={setCitizenshipDriver}
              countryCode={driverCitizenshipCode}
              setIsCountrySelect={setIsCountrySelect}
              isCountrySelect={isCountrySelect}
              value={citizenshipDriver}
              inputRef={citizenshipDriverInput}
              httpRef={(el: HTMLInputElement) => citizenshipDriverInput = el}
              onFocus={() => {
                setActiveInput(citizenshipDriverInput)
                setFormatInput('')
              }}
              isActive={activeInput === citizenshipDriverInput}
              autoFocus={false}
              onClick={() => {
                setShowKeyboard(true)
                updateCaretPosition()
              }}
              setIsError={setIsNoCountry}
              clearInputField={clearInputField}
              onKeyDown={onKeyboardDown}
              caretRef={refCountryCaret}
              errors={{inputError: isNoCountry || isInputFieldsError.isCountryNameError}}
            />
          </div>
          <div className="drivers-information-row">
            <FormFieldInput
              id="date-of-birth-driver"
              type={INPUT_TYPE.DATE}
              classFormField={`drivers-form-field`}
              classInput={'birth-date'}
              label={t('dateOfBirth')}
              isClearNeed={!!dateOfBirthDriver.driverBirthDate}
              clearInputField={clearInputField}
              errors={{ inputError: isInputFieldsError.isBirthDateError }}
              inputRef={dateOfBirthDriverInput}
              value={dateOfBirthDriver.driverBirthDate}
              onChange={onChange}
              onFocus={() => {
                setActiveInput(dateOfBirthDriverInput.current)
                setFormatInput('date')
              }}
              onClick={() => {
                setShowKeyboard(true)
                updateCaretPosition()
              }}
              onKeyDown={onKeyboardDown}
              caretRef={refDateOfBirthCaret}
              isActive={activeInput === dateOfBirthDriverInput.current}
            />
            <FormField id="gender-driver" classFormField="form-field drivers-form-field" label={t('gender')}>
              <Gender
                setGender={genderSelected}
                gender={driverGender}
                isError={isInputFieldsError.isGenderInputError}
              />
            </FormField>
            <div className="next-button">
              <button className="main-button" onClick={() => onClick()}>
                {t('next')}
              </button>
            </div>
          </div>
        </div>
      </div>
      {isKioskMode && <div className="keyboard-cont">
        {isKeyboardShown && (
          <Keyboard
            input={activeInput}
            onChange={onChange}
            format={formatInput}
            onClose={() => setShowKeyboard(false)}
          />
        )}
      </div>}
      <div className="footer-cont">{(!isKeyboardShown || !isKioskMode) && <Footer />}</div>
    </React.Fragment>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
